<template>
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="icons/lens-bold">
      <path
        id="Union"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.33413 10.1481C9.33413 7.10048 11.8047 4.62988 14.8524 4.62988C17.9 4.62988 20.3706 7.10048 20.3706 10.1481C20.3706 13.1957 17.9 15.6663 14.8524 15.6663C11.8047 15.6663 9.33413 13.1957 9.33413 10.1481ZM14.8524 2.62988C10.7002 2.62988 7.33413 5.99591 7.33413 10.1481C7.33413 11.8637 7.90879 13.4452 8.87613 14.7104L2.73828 20.8482L4.15249 22.2624L10.2904 16.1246C11.5555 17.0918 13.1369 17.6663 14.8524 17.6663C19.0046 17.6663 22.3706 14.3003 22.3706 10.1481C22.3706 5.99591 19.0046 2.62988 14.8524 2.62988Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>
